import QueryRequest from "./components/query-request/query-request";
import QueryRequestTabs from "./components/query-request-tabs";
import { ContentContainer, PageLayout } from "components/layout";

const Updates = () => {
  return (
    <PageLayout>
      <ContentContainer>
        <div className="w-full flex flex-col lg:flex-row items-start justify-center gap-8">
          <div className="w-full lg:w-[55%]">
            <QueryRequest />
          </div>
          <div className="w-full lg:w-[45%]">
            <QueryRequestTabs />
          </div>
        </div>
      </ContentContainer>
    </PageLayout>
  );
};

export default Updates;
